import React, { Component } from 'react'
import authHeader from "helpers/authHeader";
import { Input } from "reactstrap"
import axios from 'axios';
import { deletePOIUrl } from "../../helpers/fakebackend_helper";

function TableRows({ rowsData, deletePoiRows, handleChange, handleCheckChange, handleUploadChange, errorMessage }) {
    $(".maxFuture").flatpickr({
        dateFormat: "d-M-Y",
        minDate: "today",
        disableMobile: "true"
    });

    function DeletePOI(poiid) {
        debugger;
        const deleteStatusModel = {
            RegistrationId: localStorage.getItem('registrationId'),
            Id: poiid
        }
        if (rowsData.length > 1) {
            axios.post(deletePOIUrl(), deleteStatusModel, { headers: authHeader() })
                .then(res => {

                })
        }
    }

    // Allowed Extension
    const allowedExtensions = ['image/png', 'image/jpeg', 'image/jpg'];

    return (
        rowsData.map((data, index) => {
            const { poiid, SelectedProofofIdentity, EnterNumber, POIPOA, Expiry, Upload, poifilepath, poifilepathurl, Delete } = data;

            return (
                <tr key={index}>
                    <td>
                        <label>{SelectedProofofIdentity}</label>
                    </td>
                    <td>
                        <input
                            type="text"
                            value={EnterNumber}
                            name="EnterNumber"
                            className="form-control"
                            id={`txtPOI.${index}`}
                            onKeyPress={e => {
                                if (e.key === 'Enter') e.preventDefault()
                            }}
                            onChange={(evnt) => (handleChange(index, evnt))}
                            maxLength="20"
                            autoComplete="off"
                        />
                    </td>
                    <td>
                        <label>{POIPOA}</label>
                    </td>
                    <td>
                        <input
                            type="text"
                            value={Expiry}
                            id={`txtexpiry.${index}`}
                            name="Expiry"
                            placeholder="Expity Date"
                            className="form-control maxFuture flatpickr"
                            onSelect={(evnt) => (handleChange(index, evnt))}
                            disabled={SelectedProofofIdentity == "UID-Aadhaar No." || SelectedProofofIdentity == "Voter ID"}
                        />
                    </td>
                    <td style={{ display: "flex" }}>
                        <Input multiple="" type="file" style={{ marginTop: "3px", width: "85%" }}
                            name="Upload"
                            accept=".jpg,.jpeg,.png"
                            id={`fileUpload.${index}`}
                            onChange={(evnt) => {
                                const fileInput = evnt.target;
                                const fileData = evnt.target.files[0];
                                if (!allowedExtensions.includes(fileData.type)) {
                                    errorMessage("Kindly upload document in JPG,JPEG,PNG format only");
                                    // Clear the file input so filename doesn't show
                                    fileInput.value = "";
                                } else {
                                    handleUploadChange(index, evnt)
                                }
                            }}
                            onKeyPress={e => {
                                if (e.key === 'Enter') e.preventDefault()
                            }}
                        />
                        {/* </Input> */}
                        <a id="lnkPOIFileDownload" href={poifilepathurl} name="poifilepath" target="_blank" rel="noreferrer" style={{ visibility: poifilepath == "" ? "hidden" : "visible", fontSize: "medium", fontWeight: "bold", marginLeft: "10px", marginTop: "10px" }}>
                            <i className="bx bx-show" style={{ fontSize: "xx-large", marginTop: "-5px" }}></i>
                        </a>
                    </td>
                    <td>
                        <button className="btn btn-danger"
                            onClick={(e) => {
                                e.preventDefault()
                                deletePoiRows(index)
                                DeletePOI(poiid)
                            }}>
                                <i className="mdi mdi-trash-can"></i>
                        </button>
                    </td>
                </tr >
            )
        })
    )
}

export default TableRows